module.exports = __webpack_public_path__ + "img/logoRGE.c0148cda.svg";